// extracted by mini-css-extract-plugin
export var anchored = "mediaContent-module--anchored--390bf";
export var buttonForImage = "mediaContent-module--buttonForImage--3c4c3";
export var buttonForVideo = "mediaContent-module--buttonForVideo--459df";
export var imageDescription = "mediaContent-module--imageDescription--81956";
export var mediaGalleryContainer = "mediaContent-module--mediaGalleryContainer--3279e";
export var mediaSliderControls = "mediaContent-module--mediaSliderControls--ad1a6";
export var mediaTextSwiper = "mediaContent-module--mediaTextSwiper--0ece5";
export var paginationElement = "mediaContent-module--paginationElement--585a1";
export var singleImage = "mediaContent-module--singleImage--47206";
export var slideIcons = "mediaContent-module--slideIcons--14de4";
export var sliderGrid = "mediaContent-module--sliderGrid--2f517";